import styled from "styled-components";

export const Header = styled.div`
  margin: 10px auto 5px;
  width: fit-content;
  display: flex;
`;
export const HeaderTitle = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  color: #808080;
  font-size: 12px;
  font-weight: 600;
  text-align: ${({ textAlign }) => textAlign && textAlign};
`;
export const MainDiv = styled.div`
  margin: auto;
  width: fit-content;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1.5px solid #fff;
  background-color: #e6e6e6;
  overflow-x: hidden;
`;
export const FunctionsDiv = styled.div`
  padding: 16px 16px 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
export const FunctionButton = styled.button`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1.5px solid #26a9b6;
  gap: 8px;
  cursor: pointer;
`;
export const FunctionText = styled.p`
  color: #26a9b6;
  font-size: 14px;
  font-weight: 600;
`;
export const InfoImg = styled.img`
  width: 20px;
  height: 20px;
`;
export const ActionsDiv = styled.div`
  margin-top: 20px;
  padding: 10px 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #e6e6e6;
  position: sticky;
  bottom: 0;
`;
export const CancelButton = styled.button`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1.5px solid #26a9b6;
  color: #26a9b6;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
export const SaveButton = styled.button`
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  background: #26a9b6;
  box-shadow: 0px 1px 0px 0px #1c7983;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
